export default __webpack_public_path__ + "assets/raindrop.1a4b41e5.svg";